import IVideoProperties from './IVideoProperties';

/**
 * Represents the types of video events that can occur.
 */
export type VideoEventType = 'prepare' | 'play' | 'stop' | 'pause' | 'resume' | 'ended' | 'error';
export const VIDEO_EVENT_TYPES: VideoEventType[] = ['prepare', 'play', 'stop', 'pause', 'resume', 'ended', 'error'];

/**
 * Represents an event related to video playback.
 */
interface IVideoEvent {
	/** The type of the video event. */
	type: VideoEventType;
	/** Properties of video that created the event */
	srcArguments: IVideoProperties;
}
export default IVideoEvent;

export function getEventName(event: IVideoEvent) {
	const srcArgumentsString = stringifySrcArguments(
		event.srcArguments.uri,
		event.srcArguments.x,
		event.srcArguments.y,
		event.srcArguments.width,
		event.srcArguments.height,
	);
	return `${event.type}_${srcArgumentsString}`;
}

export function stringifySrcArguments(uri: string, x: number, y: number, width: number, height: number) {
	return `${uri}$${x}_${y}_${width}_${height}`;
}
